import React, { createContext, useState, useMemo, useEffect } from 'react'
import Amplify, { Auth } from 'aws-amplify'
import awsconfig from "./aws-exports";
import { AmplifyAuthenticator, AmplifySignOut, AmplifySignIn, AmplifyAuthContainer } from '@aws-amplify/ui-react'
import { AuthState, onAuthUIStateChange, VerifyCurrentUser } from '@aws-amplify/ui-components';


// This handles the logged in user.
// 

export const UserContext = createContext()

export const UserProvider = ({ children }) => {

  const [authState, setAuthState] = useState();
  const [activeUser, setActiveUser] = useState()
  const [userGroups, setUserGroups] = useState()

  async function signOut() {
    try {
      await Auth.signOut();
      await setActiveUser(null)
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }


  useEffect(() => {
    if (authState === undefined) {
      Auth.currentAuthenticatedUser().then(authData => {
        setAuthState(AuthState.SignedIn);
        setActiveUser(authData);
        // console.log(authData.attributes)
      });
    }
    return onAuthUIStateChange((nextAuthState, authData) => {
      setAuthState(nextAuthState);
      setActiveUser(authData);
      // Auth.currentSession()
      //   .then(data => console.log(data))
      //   .catch(err => console.log(err));
      Auth.currentAuthenticatedUser()
        .then(data => setUserGroups(data.signInUserSession.accessToken.payload['cognito:groups']))
        .catch(err => console.log(`error: ${err}`));
      Auth.currentUserInfo()
        //   // .then(data => console.log(data))
        .then(data => setActiveUser(data))
        .catch(err => Auth.signOut());
    });
  }, [authState]);



  // useEffect(() => {
  //   const unsubscribe = onAuthUIStateChange((nextAuthState, authData) => {
  //     setAuthState(nextAuthState);
  //     setActiveUser(authData);
  //     Auth.currentSession()
  //       // .then(data => console.log(data))
  //       .catch(err => console.log(err));
  //     Auth.currentUserInfo()
  //       // .then(data => console.log(data))
  //       // .then(data => setActiveUser(data))
  //       .catch(err => Auth.signOut());
  //     // .catch(err => console.log(err));
  //     Auth.currentAuthenticatedUser()
  //       .then(data => setUserGroups(data.signInUserSession.accessToken.payload['cognito:groups']))
  //       // .then(data => console.log(data))

  //       .catch(err => console.log(`error: ${err}`));
  //   });
  //   return () => unsubscribe();

  // }, []);


  // console.log(authState, activeUser)


  const providerValue = useMemo(() => ({ authState, setAuthState, activeUser, setActiveUser, userGroups }), [authState, setAuthState, activeUser, setActiveUser, userGroups])




  return (
    <UserContext.Provider value={providerValue}>
      {children}
    </UserContext.Provider>
  )
};
